import type {RootState} from 'store/store';

export const getPulseUser = (state: RootState) => state.auth.pulseUser;
